import { ReactNode } from "react";

import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionProps,
  Box
} from "@chakra-ui/react";

interface CustomAccordion extends AccordionProps {
  title: string;
  children: ReactNode;
}

export function ModalAccordion({ title, children, ...rest }: CustomAccordion) {
  return (
    <AccordionItem>
      <AccordionButton
        bgColor={"ll-blue.main"}
        borderRadius={"50px"}
        mb={"10px"}
        _hover={{
          opacity: "0.5"
        }}
      >
        <Box textAlign={"start"} w={"full"} color="white">
          {title}
        </Box>
        <AccordionIcon color="white" />
      </AccordionButton>
      <AccordionPanel mt="1rem" mb="1rem">
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
}
